<template>
  <div class="install">
    <h4>
      {{ partner.name }} - {{ steps[index].key | setText(steps[index].title) }}
    </h4>
    <template v-for="(step, stepKey) in steps">
      <template v-if="index === stepKey">
        <component
          :createTransaction="createTransaction"
          :partner_id="partner_id"
          :transaction="transaction"
          :updateOrder="updateOrder"
          @getLimitUser="getLimitUser"
          :limit_user="limit_user"
          :index="index"
          :is="step.key"
          :key="stepKey"
          @next="next"
          :order="order"
          @getHash="getHash"
          :hash="hash"
          @getBuyer="getBuyer"
          :buyer="buyer"
          @getContract="getContract"
          :contract="contract"
          :partner="partner"
        />
      </template>
    </template>
  </div>
</template>
<script>
export default {
  props: [
    "order",
    "updateOrder",
    "partner_id",
    "createTransaction",
    "transaction",
    "partner",
  ],
  methods: {
    next(index = 0) {
      if (index < 0) {
        this.$emit("close", true);
      }
      this.index = index;
    },
    getHash(val) {
      this.hash = val;
    },
    getBuyer(val) {
      this.buyer = val;
    },
    getLimitUser(val) {
      this.limit_user = val;
    },
    getContract(val) {
      this.contract = val;
    },
  },
  name: "filter",
  watch: {
    index(val) {
      if (val < 0 || val >= this.steps.length) {
        this.$modal.hide("install");
        this.index = 0;
      }
    },
  },
  mounted() {},
  components: {
    "client-check": () => import("./ClientCheck"),
    "client-uzum": () => import("./ClientUzum"),
    "order-add": () => import("./OrderAdd"),
    "order-client-verify": () => import("./OrderClientVerify"),
    "order-retail-verify": () => import("./OrderRetailVerify"),
    "order-upload-act": () => import("./OrderUploadAct"),
  },
  async created() {
    if (this.transaction) {
      this.contract = this.transaction["exchange_id"];
      if (this.transaction["status"] == -1) {
        alert("Заказ был отменен");
        this.$emit("close", true);
      } else if (this.transaction["client_confirmed"] === false) {
        this.index = 0;
      } else if (
        this.transaction["client_confirmed"] === true &&
        this.transaction["system_confirmed"] === false
      ) {
        this.index = 4;
      } else if (
        this.transaction["client_confirmed"] === true &&
        this.transaction["system_confirmed"] === true
      ) {
        this.index = 5;
      } else {
        this.index = 5;
      }
    }
  },
  data() {
    return {
      hash: null,
      buyer: null,
      limit_user: 0,
      contract: null,
      index: 0,
      steps: [
        {
          title: "Проверка клиента", //0
          key: "client-check",
        },
        {
          title: "Регистрация нового клиента", //1
          key: "client-uzum",
        },
        {
          title: "Создание заказа", //2
          key: "order-add",
        },
        {
          title: "Подтверждение клиента", //3
          key: "order-client-verify",
        },
        {
          title: "Подтверждение заказа", //4
          key: "order-retail-verify",
        },
        {
          title: "Загрузка файлов", //5
          key: "order-upload-act",
        },
      ],
    };
  },
};
</script>

